import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(seleccionarHerramienta),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchSeleccionarHerramienta);

import { takeEvery, put, select } from 'redux-saga/effects';
import { HERRAMIENTA_SELECCIONAR, mostrarImagenUsuario } from // mostrarTextosUsuario
'../../actions';
import { mostrarTextosUsuario, modoCrearTexto } from '../../texto-usuario/actions';
import { GRUPO_TEXTO, GRUPO_PIZARRA, GRUPO_MASCARAS, GRUPO_GENERAL, MOSTRAR_ID } from '../../herramientas/constantes';
import { seleccionarHerramientaGrupoTexto } from './grupo-texto';
import { seleccionarHerramientaGrupoPizarra } from './grupo-pizarra';
import { seleccionarHerramientaGrupoMascaras } from './grupo-mascaras';
import { seleccionarHerramientaGrupoGeneral } from './grupo-general';
import { getImagenUsuarioVisible, getTextosUsuarioVisible } from '../../selectors';
import { getModoCrear } from '../../texto-usuario/selectors';
import { getEditorActivo } from '../../pizarra/selectors';
import { desactivarEditor } from '../../pizarra/actions';
import * as actionsMascaras from '../../mascaras/actions';
import * as mascarasSelectors from '../../mascaras/selectors';
import * as actionsCartulina from '../../cartulina/actions';
import * as cartulinaSelectors from '../../cartulina/selectors';
import * as actionsPersiana from '../../persiana/actions';
import * as persianaSelectors from '../../persiana/selectors';

function seleccionarHerramienta(action) {
  var imagenUsuarioVisible, textosUsuarioVisible, modoCrearTextoActivo, editorActivo, mascarasActivas, cartulinaActiva, persianaActiva;
  return _regeneratorRuntime.wrap(function seleccionarHerramienta$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(action.herramientaId !== MOSTRAR_ID)) {
            _context.next = 13;
            break;
          }

          _context.next = 3;
          return select(getImagenUsuarioVisible);

        case 3:
          imagenUsuarioVisible = _context.sent;

          if (imagenUsuarioVisible) {
            _context.next = 7;
            break;
          }

          _context.next = 7;
          return put(mostrarImagenUsuario());

        case 7:
          _context.next = 9;
          return select(getTextosUsuarioVisible);

        case 9:
          textosUsuarioVisible = _context.sent;

          if (textosUsuarioVisible) {
            _context.next = 13;
            break;
          }

          _context.next = 13;
          return put(mostrarTextosUsuario());

        case 13:
          if (!(action.grupo !== GRUPO_TEXTO)) {
            _context.next = 20;
            break;
          }

          _context.next = 16;
          return select(getModoCrear);

        case 16:
          modoCrearTextoActivo = _context.sent;

          if (!modoCrearTextoActivo) {
            _context.next = 20;
            break;
          }

          _context.next = 20;
          return put(modoCrearTexto(false));

        case 20:
          if (!(action.grupo !== GRUPO_PIZARRA)) {
            _context.next = 27;
            break;
          }

          _context.next = 23;
          return select(getEditorActivo);

        case 23:
          editorActivo = _context.sent;

          if (!editorActivo) {
            _context.next = 27;
            break;
          }

          _context.next = 27;
          return put(desactivarEditor());

        case 27:
          if (!(action.grupo !== GRUPO_MASCARAS)) {
            _context.next = 46;
            break;
          }

          _context.next = 30;
          return select(mascarasSelectors.getActivas);

        case 30:
          mascarasActivas = _context.sent;

          if (!mascarasActivas) {
            _context.next = 34;
            break;
          }

          _context.next = 34;
          return put(actionsMascaras.desactivar());

        case 34:
          _context.next = 36;
          return select(cartulinaSelectors.getActiva);

        case 36:
          cartulinaActiva = _context.sent;

          if (!cartulinaActiva) {
            _context.next = 40;
            break;
          }

          _context.next = 40;
          return put(actionsCartulina.desactivar());

        case 40:
          _context.next = 42;
          return select(persianaSelectors.getActiva);

        case 42:
          persianaActiva = _context.sent;

          if (!persianaActiva) {
            _context.next = 46;
            break;
          }

          _context.next = 46;
          return put(actionsPersiana.desactivar());

        case 46:
          _context.t0 = action.grupo;
          _context.next = _context.t0 === GRUPO_TEXTO ? 49 : _context.t0 === GRUPO_PIZARRA ? 51 : _context.t0 === GRUPO_MASCARAS ? 53 : _context.t0 === GRUPO_GENERAL ? 55 : 57;
          break;

        case 49:
          return _context.delegateYield(seleccionarHerramientaGrupoTexto(action), 't1', 50);

        case 50:
          return _context.abrupt('break', 57);

        case 51:
          return _context.delegateYield(seleccionarHerramientaGrupoPizarra(action), 't2', 52);

        case 52:
          return _context.abrupt('break', 57);

        case 53:
          return _context.delegateYield(seleccionarHerramientaGrupoMascaras(action), 't3', 54);

        case 54:
          return _context.abrupt('break', 57);

        case 55:
          return _context.delegateYield(seleccionarHerramientaGrupoGeneral(action), 't4', 56);

        case 56:
          return _context.abrupt('break', 57);

        case 57:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function watchSeleccionarHerramienta() {
  return _regeneratorRuntime.wrap(function watchSeleccionarHerramienta$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(HERRAMIENTA_SELECCIONAR, seleccionarHerramienta);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

export default watchSeleccionarHerramienta;